import { type ReactNode, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { IoCloseOutline } from 'react-icons/io5';

import s from './Modal.module.scss';

type ModalProps = {
  open?: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
};

export const Modal = ({ open = false, onClose, title, children }: ModalProps) => {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className={s.backdrop} onClick={onClose}>
      <div className={s.modal} onClick={(e) => e.stopPropagation()}>
        {title != null && <div className={s.title}>{title}</div>}
        <button className={s.closeBtn} onClick={onClose} aria-label="Close">
          <IoCloseOutline />
        </button>
        <div className={s.content}>{children}</div>
      </div>
    </div>,
    document.body,
  );
};
